import { useIntl } from 'react-intl';
import {
  BreadcrumbItem,
  Breadcrumbs,
} from '@rossum/components/breadcrumbs/Breadcrumbs';
import { automationPath } from './helpers';

type AutomationBreadcrumbsProps = {
  breadcrumbs: BreadcrumbItem[];
};

export const AutomationBreadcrumbs = ({
  breadcrumbs,
}: AutomationBreadcrumbsProps) => {
  const intl = useIntl();

  const automationBreadcrumbs = [
    {
      to: automationPath(),
      label: intl.formatMessage({ id: 'components.appBar.automation' }),
    },
    ...breadcrumbs,
  ] as const;

  return <Breadcrumbs breadcrumbs={automationBreadcrumbs} />;
};
